'use client';

import { createContext } from 'react';

import { FeatureToggle } from '@ravago/shared/page-data/models/config';

export const FeatureToggleContext = createContext<FeatureToggle[]>([]);
